import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnDestroy,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { AuthService } from '@core/auth/auth.service';
import { Router } from '@angular/router';
import * as _ from 'lodash-es';
import { TicketManager } from '@routes/ticket-manager';
import { finalize, takeWhile } from 'rxjs/operators';
import { document } from 'ngx-bootstrap/utils';
import { EventService } from '@shared/services/event.service';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { MenuService } from '@layouts/menu/menu.service';
import Utils from '@shared/utils/utils';
import { MenuItem } from '@layouts/menu/menu.model';
import { Location } from '@angular/common';
import { SpinnerService } from '@shared/services/spinner.service';
import { ApiService } from '@shared/apis';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';
import { environment } from '@env/environment';
import { Constants } from '@shared/constants/constants';
import { MfaRegisterComponent } from '@routes/auth/mfa/mfa-register/mfa-register.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import Swal from 'sweetalert2';
import {UserEditComponent} from "@routes/users/user-edit/user-edit.component";

export interface MainTabs {
  title?: string;
  active?: boolean;
  ticketNo?: string;
  isEdit?: boolean;
  menu?: MenuItem;
}

const TOP_RIGHT_WIDTH = 130;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  readonly environment = environment;
  profileName = 'prod';
  bsModalRef: BsModalRef;

  myInfo: any;

  tabs: MainTabs[] = [];
  tabClick: any;
  selectedMenu: any;

  tickets: any[]

  tabItemSize = 160;
  scrollOnOff = false;

  currentCompanyCode: any;
  currentCompany: any;
  companyCodes: any[];
  companies: any[];
  topRightWidth = TOP_RIGHT_WIDTH;
  isAdminViewerRole: boolean;
  isBuilder: boolean = false;
  showHelpIcon: boolean = false;
  companyList: any[];
  userDetail: any = {};


  // ticket: Ticket;

  @Output() selectedTabEvent = new EventEmitter<any>();

  @ViewChild('navbarHeader') navbarHeader: ElementRef;
  @ViewChild('tabSetEl') tabSetEl: ElementRef;
  @ViewChild('searchText') searchText: ElementRef;
  @ViewChild('dropdown') dropdown: BsDropdownDirective;
  protected readonly Constants = Constants;
  private alive = true;

  constructor(private authService: AuthService,
              private cdRef: ChangeDetectorRef,
              public ticketManager: TicketManager,
              private menuService: MenuService,
              private eventService: EventService,
              private location: Location,
              private spinnerService: SpinnerService,
              private apiService: ApiService,
              private modalService: BsModalService,
              private router: Router) {
    // this.isTickets = this.router.url.split('/').includes('tickets');
    // console.log('====', this.isTickets);
    this.isAdminViewerRole = this.authService.checkHasAdminViewerRole();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkScroll();
  }

  ngOnInit(): void {

    this.myInfo = this.authService.getUser();
    this.profileCheck();
    this.currentCompanyCode = this.authService.getCurrentCompany();
    this.selectCompany(this.currentCompanyCode);
    this.showHelpIcon = this.currentCompanyCode === Constants.companies[0].code;
    this.companyList = this.authService.setCodes();

    this.eventService.closeTab$
      .pipe(takeWhile(() => this.alive))
      .subscribe(obj => {
        if (obj.constructor === {}.constructor) {
          this.closeTab(obj);
        }
      });

    this.menuService.selectedMenu$
      .pipe(takeWhile(() => this.alive))
      .subscribe((menu: MenuItem) => {
        if (menu) {
          const findComponent = _.findIndex(this.tabs, (t) => {
            return t.menu.componentId === menu.componentId;
          });

          if (findComponent === -1) {
            if (this.tabs.length >= 15) {
              Utils.showError('The menu cannot be opened more than 15');
              return;
            }

            this.tabs.push({
              active: true,
              menu,
            });
          } else {
            this.tabs = this.tabs.map(tab => {
              tab.active = tab.menu.componentId === menu.componentId;
              return tab;
            });
          }
          this.cdRef.detectChanges();
        }
      });

    this.ticketManager.activeTicket$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticket => {
        if (!ticket) {
          return;
        }

        const { status } = ticket;
        if ('changed' === status) {
          const findOpenTicket: any = this.tabs.find(f => f.ticketNo === ticket.ticketInfo.previousTicketNo);
          const { ticketNo } = ticket.ticketInfo;
          findOpenTicket.title = ticketNo;
          findOpenTicket.ticketNo = ticketNo;
        } else {
          const findOpenTicket: any = this.tabs.find(f => f.ticketNo === ticket.ticketInfo.ticketNo);

          if (findOpenTicket) {
            findOpenTicket.isEdit = ticket?.isEdit;
            findOpenTicket.active = true;
          } else {
            // Add Tab Ticket View
            const { ticketNo, status } = this.ticketManager.activeTicket.ticketInfo;
            const title = status === 'new' ? `New Ticket` : ticketNo;

            const tabInfo = {
              active: true,
              title,
              ticketNo,
              menu: {
                componentId: 'ticketEdit',
              },
            };

            this.tabs.push(tabInfo);
            this.selectedComponent(tabInfo);
          }
        }

        const tab = this.tabs.find(f => f?.ticketNo === ticket.ticketInfo.ticketNo);
        const ticketPath = ticket.ticketInfo.status === 'new' ? `/tickets/new/${ tab.ticketNo }` : `/tickets/${ tab.ticketNo }`;
        this.location.replaceState(ticketPath);

        this.cdRef.detectChanges();
        this.checkScroll();
      });

    this.ticketManager.headerTabChanged$
      .pipe(takeWhile(() => this.alive))
      .subscribe(ticketInfo => {
        if (ticketInfo && ticketInfo.prevTicketNo) {
          const prevTicketNo = ticketInfo.prevTicketNo;
          const ticketNo = ticketInfo.ticketNo;
          const find = this.tabs.find(f => f?.ticketNo === prevTicketNo);
          find.title = ticketNo;
          find.ticketNo = ticketNo;
          const ticketPath = `/tickets/${ ticketNo }`;

          const activeTab = this.tabs.find(f => f.active);
          if (activeTab.ticketNo === ticketNo) {
            this.location.replaceState(ticketPath);
          }
        }
      });

    this.builderCheck();
  }

  profileCheck() {
    switch (this.environment.environment) {
      case 'dev':
        this.profileName = 'dev';
        break;
      case 'local':
        this.profileName = 'local';
        break;
      default:
        this.profileName = '';
        break;
    }
  }

  ngOnDestroy() {
    this.alive = false;
    this.ticketManager.end();
  }

  /**
   * Logout the user
   */
  logout(ev) {
    ev.stopPropagation();
    ev.preventDefault();

    this.authService.logout();
  }

  closeTab(tab) {
    if (tab.ticketNo) {
      this.ticketManager.unsubscribePusher(`private-ticket-${ tab.ticketNo }`);
      _.remove(this.tabs, (t) => {
        _.remove(this.ticketManager.tickets, (t) => t.ticketInfo.ticketNo === tab.ticketNo);
        this.eventService.closeTab$.next(tab.ticketNo);
        return t.ticketNo === tab.ticketNo;
      });
    } else {
      _.remove(this.tabs, t => t === tab);
    }

    if (this.tabs.length) {
      const lastIdx = this.tabs.length - 1;
      const lastTab = this.tabs[lastIdx];
      lastTab.active = true;
      this.selectedComponent(lastTab);

      if (lastTab.ticketNo) {
        if (this.ticketManager.tickets.length) {
          this.ticketManager.activeTicket = this.ticketManager.tickets.find(f => f.ticketInfo.ticketNo === lastTab.ticketNo) || null;
        } else {
          this.ticketManager.activeTicket = null;
        }
      }
    }
  }

  selectedComponent(tab) {
    const { menu } = tab;
    this.selectedMenu = menu;
    this.tabClick = menu.componentId;
    this.selectedTabEvent.emit(this.selectedMenu);
    this.cdRef.detectChanges();

    this.checkScroll();
  }

  selectTab($event: TabDirective, i) {
    const tab = this.tabs[i];
    tab.active = $event.active;

    this.selectedComponent(tab);
    if (tab.ticketNo) {
      this.ticketManager.activeTicket = this.ticketManager.tickets.find(f => f.ticketInfo.ticketNo === tab.ticketNo);
    } else {
      this.ticketManager.activeTicket = null;
    }

    if (tab.menu.componentId !== 'ticketEdit') {
      this.location.replaceState(tab.menu.componentId);
    }
  }

  addTabTicket() {
    this.ticketManager.addTicket(null);
  }

  scrollTab(dir) {
    const tabsScroll = document.querySelector('#topContainer tabset ul');
    if (!tabsScroll) {
      return;
    }

    if (dir === 'left') {
      tabsScroll.scrollLeft -= this.tabItemSize;
    } else {
      tabsScroll.scrollLeft += this.tabItemSize;
    }
  }

  checkScroll() {
    if (!this.ticketManager.tickets?.length) {
      return
    }

    this.scrollOnOff = this.tabSetEl?.nativeElement.offsetWidth > (this.navbarHeader.nativeElement.offsetWidth - 396) - TOP_RIGHT_WIDTH;
    document.querySelector('#topContainer tabset ul').scrollLeft = this.tabs.findIndex(f => f.active) * 200;
  }

  search(value) {
    this.spinnerService.start();
    this.apiService.ticket.getTicket(value)
      .pipe(finalize(() => this.spinnerService.stop()))
      .subscribe(res => {
        if (res) {
          this.dropdown.hide();
          this.ticketManager.addTicket(res, false);
        }
      }, err => Utils.showError(err));
  }

  openDropdown() {
    setTimeout(() => {
      if (this.searchText) {
        this.searchText.nativeElement.value = '';
        this.searchText.nativeElement.focus();
      }
    });
  }

  selectCompanyAndReload(companyCode) {
    this.selectCompany(companyCode);
    this.reload();
  }

  selectCompany(companyCode) {
    this.authService.setCompany(companyCode);
    this.currentCompanyCode = companyCode;
    this.currentCompany = Constants.companies.find(company => company.code === companyCode);
    this.companyCodes = this.authService.getCompanies();
    this.companies = Constants.companies.filter(company => this.companyCodes.includes(company.code));
  }

  reload() {
    const currentUrl = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([currentUrl]).then(() =>
        window.location.reload());
    });
  }

  registerMFA() {
    this.spinnerService.start('other-layout-spinner');
    this.authService.getQRCode()
      .pipe(finalize(() => this.spinnerService.stop('other-layout-spinner')))
      .subscribe(result => {
        const { qrCode } = result;
        const initialState = {
          qrCode,
        };
        this.bsModalRef = this.modalService.show(MfaRegisterComponent, { initialState, class: 'modal-lg' });
        this.bsModalRef.content.onClose.subscribe(() => {
          Utils.showMessage('MFA device registered successfully.');
        }, err => {
          Utils.showError(err, 'MFA Register');
        });

      });
  }

  builderCheck() {
    this.apiService.dealer.getDealer(this.myInfo.organization).subscribe(res => {
      this.isBuilder = res?.purchasePlaceCode === Constants.purchasePlace.BUILDER;
    }, err => {
    })
  }

  showHelpModal() {
    this.router.navigate(['/training-video']);
  }

  async editUserInfo() {
    const userInfoPromise = new Promise((resolve, reject) => {
      this.spinnerService.start();
      this.apiService.user.getSimpleProfile(this.myInfo.username)
        .pipe(finalize(() => this.spinnerService.stop()))
        .subscribe(res => {
          this.userDetail = res;
          resolve(res)
        }, err => Utils.showError(err));
    })

    await Promise.all([userInfoPromise]).then((resolve: any) => {
      this.userDetail.selectedBPs = this.userDetail.bps;
      const initialState = {
        title: 'User Edit',
        userInfo: this.userDetail,
        simpleEdit: true,
        profileOption: '-profile'
      };
      this.bsModalRef = this.modalService.show(UserEditComponent, {
        initialState,
        class: 'modal-lg',
        ignoreBackdropClick: true,
      });
      this.bsModalRef.content.onClose.subscribe(result => {
        this.myInfo = {
          ...this.myInfo,
          firstName: result.firstName,
          lastName: result.lastName
        };
      });
    })
  }
}
